import { breadcrumb } from './breadcrumb';
import { campaign } from './campaign';
import { stats } from './stats';
import { webhook } from './webhook';
import { operators } from './operators';
import { task } from './task';
import { monitoring } from './monitoring';
import { monitoring_general } from './monitoring_general';

export const autocaller_v2 = {
  breadcrumb,
  campaign,
  stats,
  webhook,
  operators,
  task,
  monitoring,
  monitoring_general,
  
  products: {
    title: "Продукт",
    tooltips: {
      usage: 'Учитывается, если в настройках кампании выбран пункт "Учитывать навыки операторов"'
    },
    table: {
      name: "Название продукта"
    },
    remove: 'Вы уверены, что хотите удалить продукт {name}?'
  },

  validator: {
    field: {
      calls_limit: {
        max_value: 'Предиктивный обзвон поддерживает не более 250 одновременных соединений.'
      },
      date_time_error: 'Время указывается позже текущего в UTC +00:00'
    }
  }
};
